import { component as defineComponent } from 'flightjs';

var xhr = null;

var UserSearch = function () {
    this.attributes({
        'apiUrl' : null
    });

    this.doSearch = function (e, query) {
        if (xhr) {
            xhr.abort();
        }

        xhr = $.get(this.attr.apiUrl, {
            q: query,
            newMarkup: true
        });

        xhr.done(function (data) {
            this.trigger('brandContainer.data.userSearch', [data]);
        }.bind(this));
    };

    this.after('initialize', function() {
        this.on('brandContainer.ui.requestUserSearch', this.doSearch);
    });
};

export default defineComponent(UserSearch);



// WEBPACK FOOTER //
// ./~/@99designs/brand-container/lib/data/user-search.js